import { React, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import {
  Stack,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  Divider,
  Modal
} from '@mui/material';
import Iconify from '../components/iconify';
import Header from './Header'
import Footer from './Footer'

const Careers = () => {
  const navigate = useNavigate();

  const jobOpenings1 = [
    {
      title: "Lead Developer",
      description: "A passionate leader and team player",
      imageUrl: "https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/info_icon_1.png",
    },
    {
      title: "Mobile Developer",
      description: "Self-motivated with a strong sense of ownership",
      imageUrl: "https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/info_icon_2.png",
    },
    {
      title: "Team Leader",
      description: "A QA Team leader with at least 5 years’ experience",
      imageUrl: "https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/info_icon_3.png",
    },
  ];

  const jobOpenings = [
    {
      title: 'Sales Executive',
      location: 'Remote',
      type: 'Full-Time',
      imageUrl: "https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/info_icon_1.png",
      responsibilities: `
        <strong>Responsibilities:</strong>
        <ul>
          <li>Identify and pursue new business opportunities in the recruitment technology sector.</li>
          <li>Build and maintain strong relationships with clients to understand their needs and provide tailored solutions.</li>
          <li>Conduct product demonstrations and presentations to prospective clients.</li>
          <li>Collaborate with the marketing team to develop effective sales strategies.</li>
        </ul>
      `,
      qualifications: `
        <strong>Qualifications:</strong>
        <ul>
          <li>Proven experience in sales, preferably in the technology or recruitment industry.</li>
          <li>Strong communication and interpersonal skills.</li>
          <li>Ability to work independently and as part of a team.</li>
          <li>A results-driven mindset with a passion for achieving targets.</li>
        </ul>
      `,
    },
    {
      title: 'AWS Architect',
      location: 'Remote',
      type: 'Full-Time',
      imageUrl: "https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/info_icon_2.png",
      responsibilities: `
        <strong>Responsibilities:</strong>
        <ul>
          <li>Design and implement scalable cloud solutions using AWS services.</li>
          <li>Collaborate with development teams to optimize applications for cloud deployment.</li>
          <li>Ensure security best practices are followed in cloud architecture.</li>
          <li>Monitor and troubleshoot cloud infrastructure for performance and reliability.</li>
        </ul>
      `,
      qualifications: `
        <strong>Qualifications:</strong>
        <ul>
          <li>Extensive experience with AWS services (EC2, S3, RDS, Lambda, etc.).</li>
          <li>Strong understanding of cloud architecture principles and best practices.</li>
          <li>Proficiency in scripting languages (Python, Bash) is a plus.</li>
          <li>Relevant AWS certifications (e.g., AWS Certified Solutions Architect) are preferred.</li>
        </ul>
      `,
    },
    {
      title: 'Node Developer',
      location: 'Remote',
      type: 'Full-Time',
      imageUrl: "https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/info_icon_3.png",
      responsibilities: `
        <strong>Responsibilities:</strong>
        <ul>
          <li>Develop scalable server-side applications using Node.js.</li>
          <li>Collaborate with front-end developers to integrate user-facing elements with server-side logic.</li>
          <li>Write clean, maintainable code and conduct code reviews.</li>
          <li>Troubleshoot and optimize application performance.</li>
        </ul>
      `,
      qualifications: `
        <strong>Qualifications:</strong>
        <ul>
          <li>Proven experience as a Node.js developer or similar role.</li>
          <li>Strong knowledge of JavaScript, RESTful APIs, and database management (MongoDB, MySQL).</li>
          <li>Familiarity with version control systems (Git).</li>
          <li>Ability to work in an Agile development environment.</li>
        </ul>
      `,
    },
  ];


  const [open, setOpen] = useState(false);
  const [selectedPostContent, setSelectedPostContent] = useState('');

  const handleOpen = (content) => {
    setSelectedPostContent(content);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <>
      {/* <Stack backgroundColor={'text.secondary'}>
        <Stack
          flexDirection={'row'}
          alignItems={'flex-end'}
          justifyContent={'space-between'}
          sx={{
            padding: 3, mt: 1.5, mb: 1.5,
            flexWrap: 'nowrap', alignItems: 'center'
          }}
        >
          <Stack flexDirection={'row'} gap={3} >
            <Typography color="white">
              Foxearch Icon
            </Typography>
            <Typography color="white" sx={{ ml: 11, cursor: 'pointer' }} onClick={() => navigate('/home')}>
              Home
            </Typography>
            <Typography color="white" sx={{ cursor: 'pointer' }} onClick={() => navigate('/contactUs')}>
              Contact Us
            </Typography>
          </Stack>

          <Stack
            flexDirection="row"
            gap={2}
            sx={{ flexWrap: 'nowrap', alignItems: 'center' }}
          >
            <Iconify icon="fontisto:world-o" width="2rem" color="white" sx={{ cursor: "pointer" }} />
            <Typography color="white" sx={{ cursor: "pointer", marginRight: 4 }} onClick={() => navigate('/login')}>Sign In</Typography>
            <Button
              sx={{
                backgroundColor: "white",
                '&:hover': {
                  backgroundColor: "white",
                }
              }}
            >
              Request Demo
            </Button>
          </Stack>
        </Stack>
        <Divider sx={{ borderColor: "white" }} />

        <Box
          sx={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            color: '#fff',
            py: 8,
            textAlign: 'center'
          }}
        >
          <Container>
            <Typography variant="h2" gutterBottom>
              Careers at Foxearch
            </Typography>
            <Typography variant="h6">
              Join our team and help us innovate the future!
            </Typography>
          </Container>
        </Box>
      </Stack> */}

      {/* <Container sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Why Join Us?
        </Typography>
        <Typography variant="body1" paragraph>
          At Foxearch, we believe in fostering a collaborative and innovative work environment. Our team is our greatest asset, and we are committed to helping them grow both professionally and personally.
        </Typography>
        <Typography variant="body1" paragraph>
          We offer competitive benefits, flexible working hours, and a culture that encourages continuous learning and development.
        </Typography>
      </Container>

      <Container sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Open Positions
        </Typography>
        <Grid container spacing={4}>
          {jobOpenings.map((job, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card>
                <CardContent>
                  <Typography variant="h6">{job.title}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    Location: {job.location}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Type: {job.type}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {job.description}
                  </Typography>
                  <Button color="custom" type="submit" variant="contained" sx={{ mt: 2 }}>
                    Apply Now
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container> */}

      {/* <Stack
        sx={{
          alignItems: 'center',
          py: 5,
          backgroundColor: '#003366',
          color: 'white',
          mt: 5,
        }}
      >
        <Typography variant="h4" gutterBottom>
          Ready to make an impact?
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#FF6600',
            '&:hover': { backgroundColor: '#E55D00' },
          }}
          onClick={() => navigate('/contactUs')}
        >
          Get in Touch
        </Button>
      </Stack> */}

      <div id="body" className="page-template page-template-page-templates page-template-full-width page-template-page-templatesfull-width-php page page-id-1277 wp-custom-logo theme-deepdigital woocommerce-no-js tribe-no-js page-template-deepdigital yith-wcbm-theme-deepdigital singular no-sidebar container-1170 meta-icons-main woo header-sticky animation-enabled elementor-default elementor-kit-2882 elementor-page elementor-page-1277" itemType="https://schema.org/WebPage" itemScope="itemscope" data-animate='{&quot;.footer-widgets .widget&quot;:&quot;fadeInUp&quot;}'
      >

        <button id="login_modal_close" aria-controls="login_dropdown" className="nav-btn" aria-expanded="true" aria-label="Login Toggler" />

        {/* </button> */}
        <div id="box" className="box-fade-in">
          <div id="top-wrap">
            <Header />

            <section id="title" className="title title-3 text-center polygon l m fs-12 background-cover cover-center nw_tbar" >
              <div className="container ">
                <h1 itemProp="headline" style={{ color: '#ed457a' }}>Careers
                </h1>
                <h6 style={{color:'#fff'}}>
                  <small>
                    At Foxearch, we believe that our people are our greatest Asset
                  </small>
                </h6>
                <nav className="breadcrumbs"><span><span><Link to="/home">Home</Link></span> &bull; <span className="breadcrumb_last" aria-current="page">Careers</span></span>
                </nav>  
              </div>
            </section>
          </div>

          <div data-elementor-type="wp-page" data-elementor-id="8199" className="elementor elementor-8199">
            <section className="elementor-section elementor-top-section elementor-element elementor-element-0532fa5 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="0532fa5" data-element_type="section">
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3cd85d3" data-id="3cd85d3" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <section className="elementor-section elementor-inner-section elementor-element elementor-element-1da5947 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="1da5947" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">

                        {jobOpenings.map((job, index) => (
                          <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-399fb4c" data-id="399fb4c" data-element_type="column">
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div className="elementor-element elementor-element-c3a90c8 elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="c3a90c8" data-element_type="widget" data-widget_type="image.default">
                                <div className="elementor-widget-container">
                                  <img decoding="async" width="60" height="53"
                                    src={job.imageUrl}
                                    className="attachment-large size-large wp-image-8201" alt="" />													</div>
                              </div>
                              <div className="elementor-element elementor-element-9be2983 elementor-widget elementor-widget-heading" data-id="9be2983" data-element_type="widget" data-widget_type="heading.default">
                                <div className="elementor-widget-container">
                                  <h2 className="elementor-heading-title elementor-size-default"><a href="#">{job.title}</a></h2>		</div>
                              </div>
                              <div className="elementor-element elementor-element-0434e0d elementor-widget elementor-widget-text-editor" data-id="0434e0d" data-element_type="widget" data-widget_type="text-editor.default">
                                <div className="elementor-widget-container">
                                  {job.type}
                                </div>
                                <div className="elementor-widget-container">
                                  {job.location}
                                </div>
                              </div>
                              <Stack sx={{ gap: 3, flexDirection: "row", mt: 2 }}>

                                <Button
                                  variant="contained"
                                  sx={{
                                    backgroundColor: "#ff497c",
                                    color: "#fff",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    padding: "5px 10px",
                                    // borderRadius: "50px",
                                    position: "relative",
                                    overflow: "hidden",
                                    "&:hover": {
                                      backgroundColor: "#e03e6b",
                                    },
                                    "&::after": {
                                      content: '""',
                                      position: "absolute",
                                      bottom: "-10px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      width: "100%",
                                      height: "15px",
                                      backgroundColor: "#ff497c",
                                      // borderRadius: "50%",
                                      zIndex: -1,
                                    },
                                  }}
                                  onClick={() => handleOpen(job)}
                                >
                                  See More
                                </Button>
                                <Button
                                  variant="contained"
                                  sx={{
                                    backgroundColor: "#ff497c",
                                    color: "#fff",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    padding: "5px 20px",
                                    // borderRadius: "50px",
                                    position: "relative",
                                    overflow: "hidden",
                                    "&:hover": {
                                      backgroundColor: "#e03e6b",
                                    },
                                    "&::after": {
                                      content: '""',
                                      position: "absolute",
                                      bottom: "-10px",
                                      left: "50%",
                                      transform: "translateX(-50%)",

                                      height: "15px",
                                      backgroundColor: "#ff497c",
                                      // borderRadius: "50%",
                                      zIndex: -1,
                                    },
                                  }}

                                >
                                  Apply
                                </Button>
                              </Stack>
                            </div>
                          </div>
                        ))}

                      </div>
                    </section>

                  </div>
                </div>
              </div>
            </section>

          </div>


          {/* <div data-elementor-type="wp-page" data-elementor-id="8199" className="elementor elementor-8199">
      <section className="elementor-section elementor-top-section elementor-element elementor-element-0532fa5 elementor-section-boxed elementor-section-height-default elementor-section-height-default">
        <div className="elementor-container elementor-column-gap-default">
          <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3cd85d3">
            <div className="elementor-widget-wrap elementor-element-populated">
              <section className="elementor-section elementor-inner-section elementor-element elementor-element-1da5947 elementor-section-boxed elementor-section-height-default elementor-section-height-default">
                <div className="elementor-container elementor-column-gap-default">
                  {jobOpenings.map((job, index) => (
                    <div
                      key={index}
                      className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ef5cf4e"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-1b7b0a8 elementor-widget elementor-widget-image">
                          <div className="elementor-widget-container">
                            <img
                              decoding="async"
                              width="60"
                              height="53"
                              src={job.imageUrl}
                              className="attachment-large size-large"
                              alt={''}
                            />
                          </div>
                        </div>
                        <div className="elementor-element elementor-element-4c1eb68 elementor-widget elementor-widget-heading">
                          <div className="elementor-widget-container">
                            <h2 className="elementor-heading-title elementor-size-default">
                              <a href="#">{job.title}</a>
                            </h2>
                          </div>
                        </div>
                        <div className="elementor-element elementor-element-1f1eb68 elementor-widget elementor-widget-text-editor">
                          <div className="elementor-widget-container">
                            <p>{job.description}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </div> */}

          {/* <Container sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom sx={{ color: '#3C6BA5' }}>
        Why Work with Us?

        </Typography>
        
        <Typography variant="body2" paragraph>
  <ul>
    <li><strong>Innovative Culture:</strong> Be part of a forward-thinking company that values fresh ideas and encourages professional growth.</li>
    <li><strong>Collaborative Environment:</strong> Work alongside talented professionals who are dedicated to making a difference in the recruitment landscape.</li>
    <li><strong>Career Development:</strong> We offer opportunities for continuous learning and career advancement, ensuring you reach your full potential.</li>
  </ul>
</Typography>

      </Container>

      <Container sx={{ mt: 4, mb:15 }}>
        <Typography variant="h4" gutterBottom sx={{ color: '#3C6BA5' }}>
        Current Job Openings
        </Typography>
        <Grid container spacing={4}>
          {jobOpenings.map((job, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ height: 450, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <CardContent sx={{ overflow: 'auto' }}>
                <Typography variant="h6" color="textSecondary">{job.title}</Typography>
                <Typography variant="body2">
                  Location: {job.location}
                </Typography>
                <Typography variant="body2">
                  Type: {job.type}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mt: 1 }}
                  dangerouslySetInnerHTML={{ __html: job.responsibilities }}
                />
                <Typography
                  variant="body1"
                  sx={{ mt: 1 }}
                  dangerouslySetInnerHTML={{ __html: job.qualifications }}
                />
              </CardContent>
              <Button
                color="custom"
                type="submit"
                variant="contained"
                sx={{ mt: 2, alignSelf: 'center', width: '28%', mb:2 }}
              >
                Apply Now
              </Button>
            </Card>
          </Grid>
          
          ))}
        </Grid>
      </Container> */}

          <section id="title" className="title title-3 text-center polygon l m fs-12 background-cover cover-center" style={{ backgroundImage: 'url(https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/06/breadcrumbs-1.jpg)' }}>
            <div className="container " style={{'margin-bottom': '30px','padding-top': '70px'}}>
              <h3 itemProp="headline" style={{ color: '#3C6BA5' }}>How to Apply
              </h3>
              <h6>
                <small>
                  If you’re excited about joining a dynamic team at Foxearch and making an impact in the recruitment industry, we’d love to hear from you! Please send your resume and a cover letter outlining your qualifications and interest in the position to hr@foxearch.com .

                  Join us at Foxearch, where your career can flourish as we simplify recruitment together!

                </small>
              </h6>

            </div>
          </section>

          

        </div>
        <Footer />
        <a id="to-top" href="#body">
          <span className="screen-reader-text">
            Go to top		</span>
        </a>

      </div>
      <div>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
         <Box
  sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "70%",
    maxHeight: "80%",
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    overflow: 'auto',
  }}
>
  <Box dangerouslySetInnerHTML={{ __html: selectedPostContent.title }} sx={{fontWeight:"bold",'color': '#3371b7','font-size': '15px'}}/>
  <Box dangerouslySetInnerHTML={{ __html: selectedPostContent.location }} />
  <Box dangerouslySetInnerHTML={{ __html: selectedPostContent.type }} sx={{mb:1}}/>
  <Box dangerouslySetInnerHTML={{ __html: selectedPostContent.responsibilities }} />
  <Box dangerouslySetInnerHTML={{ __html: selectedPostContent.qualifications }} />

  {/* You can add your close button here */}
  {/* <Box sx={{ textAlign: 'center' }}>
    <Button variant="contained" onClick={handleClose}>
      Close
    </Button>
  </Box> */}
</Box> 



        </Modal>
      </div>
    </>
  );
};

export default Careers;
